import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../core/config/app.config';
import { Observable } from 'rxjs';
import { IAuditDataParams } from './audit-data-params.interface';
import { IAuditTrailItem } from './audit-trail-item.interface';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);

  public loadAuditTrailData(
    params: IAuditDataParams,
    filter: Record<string, unknown>,
  ): Observable<IAuditEntriesResponse> {
    return this.http.post<IAuditEntriesResponse>(this.config.buildUri('audit') + '/AuditEntries', {
      ...params,
      filter,
    });
  }

  public loadAuditActionTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.config.buildUri('audit') + '/AuditActionTypes');
  }
}

export class IAuditEntriesResponse {
  metaData: IAuditDataParams;
  data: IAuditTrailItem[];
}
